export const NAV = {
  sidebarDashboard: "nav-dashboard",
  sidebarClienti: "nav-clienti",
  sidebarRichiami: "nav-richiami",
  sidebarCalendario: "nav-calendario",
  sidebarRicerca: "nav-ricerca-note",
  sidebarBackup: "nav-backup",
  searchGlobal: "topbar-search",
  newReminderBtn: "topbar-new-reminder",
  newClientBtn: "topbar-new-client",
};

export const DASH = {
  kpiClientiTot: "kpi-clienti-totali",
  kpiRichiamiOggi: "kpi-richiami-oggi",
  kpiRichiamiScaduti: "kpi-richiami-scaduti",
  kpiRichiamiSettimana: "kpi-richiami-settimana",
  reminderCard: (id) => `dash-reminder-${id}`,
  reminderToggle: (id) => `dash-reminder-toggle-${id}`,
  chartCategorie: "chart-categorie",
  chartStati: "chart-stati",
};

export const CLI = {
  searchInput: "clienti-search",
  filterCategoria: "clienti-filter-categoria",
  filterStato: "clienti-filter-stato",
  row: (id) => `client-row-${id}`,
  dialog: "client-dialog",
  fieldRagioneSociale: "client-field-ragione-sociale",
  fieldSede: "client-field-sede",
  fieldCitta: "client-field-citta",
  fieldProvincia: "client-field-provincia",
  fieldCap: "client-field-cap",
  fieldEmail: "client-field-email",
  fieldTelefono: "client-field-telefono",
  fieldFax: "client-field-fax",
  fieldRespNome: "client-field-resp-nome",
  fieldRespTel: "client-field-resp-tel",
  fieldRespEmail: "client-field-resp-email",
  fieldRefNome: "client-field-ref-nome",
  fieldRefTel: "client-field-ref-tel",
  fieldRefEmail: "client-field-ref-email",
  fieldCategoria: "client-field-categoria",
  fieldStato: "client-field-stato",
  fieldNoteGen: "client-field-note-generali",
  saveBtn: "client-save",
  deleteBtn: "client-delete",
  detailTabs: "cliente-tabs",
  noteText: "note-text",
  noteDate: "note-date",
  noteSubmit: "note-submit",
  noteRow: (id) => `note-row-${id}`,
  noteDelete: (id) => `note-delete-${id}`,
};

export const REM = {
  dialog: "reminder-dialog",
  fieldTitolo: "reminder-field-titolo",
  fieldDescrizione: "reminder-field-descrizione",
  fieldScheduled: "reminder-field-scheduled",
  fieldPriorita: "reminder-field-priorita",
  fieldClient: "reminder-field-client",
  saveBtn: "reminder-save",
  deleteBtn: "reminder-delete",
  filterTab: (v) => `reminder-tab-${v}`,
  row: (id) => `reminder-row-${id}`,
  toggle: (id) => `reminder-toggle-${id}`,
  edit: (id) => `reminder-edit-${id}`,
};
